export const PAYMENT_EVENTS = {
  /** 积分更新 */
  USER_CREDIT_UPDATE: 'userCreditUpdate',
  /** 权益变更完成 */
  EQUITY_CHANGE_FINISH: 'equityChangeFinish',
  /** 试用套餐支付提醒 */
  TRIAL_PACKAGE_PAYMENT_REMINDER: 'trialPackagePaymentReminder',
} as const;
